import React from "react";

interface BottomRightCornerProps {
  className?: string;
}

const BottomRightCorner: React.FC<BottomRightCornerProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 1.5C9.5 1.23478 9.43754 0.937536 9.25 0.75C9.06246 0.562464 8.76522 0.5 8.5 0.5M1.5 0.5C1.23478 0.5 0.937536 0.562464 0.75 0.75C0.562464 0.937536 0.5 1.23478 0.5 1.5M0.5 8.5C0.5 8.76522 0.562464 9.06246 0.75 9.25C0.937536 9.43754 1.23478 9.5 1.5 9.5M9.5 6C9.5 6 9.5 6.05474 9.5 6.25C9.5 8.25 8 9.5 6 9.5M0.5 6.5V6M9.5 4V3.5M0.5 4V3.5M6.5 0.5H6M4 9.5H3.5M4 0.5H3.5"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BottomRightCorner;
